var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStoreManager(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ffc600;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M597.333,597.731h0a8,8,0,0,0-8,8h0a8,8,0,0,0,8,8h0a8,8,0,0,0,8-8h0A8,8,0,0,0,597.333,597.731Zm-1.64,3.106a.176.176,0,0,1,.158-.068h2.963a.244.244,0,0,1,.158.068.257.257,0,0,1,.068.181l-.317,3.573a.223.223,0,0,1-.226.2h-2.329a.241.241,0,0,1-.226-.2l-.317-3.573A.257.257,0,0,1,595.693,600.837Zm7.293,7.531a1,1,0,0,1-1,1h-9.318a1,1,0,0,1-1-1v-.475a1.018,1.018,0,0,1,.769-.972v-.339a4.859,4.859,0,0,1,2.262-4.134l.2,2.235,0,.056.011.056a1.282,1.282,0,0,0,1.245,1.038H598.5a1.257,1.257,0,0,0,1.263-1.176l.2-2.2a4.908,4.908,0,0,1,.838.666,4.838,4.838,0,0,1,1.425,3.46v.339a1.018,1.018,0,0,1,.769.972Z",
    transform: "translate(-589.333 -597.731)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreManager);
export default __webpack_public_path__ + "static/media/store-manager.6a56e868396bfee1d54b9301d3f6f5fb.svg";
export { ForwardRef as ReactComponent };